import React from 'react';

import B2CSection from '../../../react4xp/components/B2CSection'

function B2CSectionPart({ bannerImage, mediaCards }) {
	return (
		<B2CSection
            banner={bannerImage.src?.link ? {
                srcSmall: bannerImage.srcSmall?.link,
                srcMedium: bannerImage.srcMedium?.link,
                srcLarge: bannerImage.srcLarge?.link,
                src: bannerImage.src?.link,
                alt: bannerImage.src?.alt
            } : undefined}
            blocks={mediaCards}
        />
	)
}

export default (props) => <B2CSectionPart {...props} />
